/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { AppNavigatorService } from "../appNavigatorService";

const is = require("is_js");

const SERVICE_NAME = "CommitteMemberReportPageService";
const log: any = LoggerModule.getInstance();

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class CommitteMemberReportPageService {
  private static instance: CommitteMemberReportPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): CommitteMemberReportPageService {
    if (!CommitteMemberReportPageService.instance) {
      CommitteMemberReportPageService.instance =
        new CommitteMemberReportPageService(props);
    }
    return CommitteMemberReportPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getCommitteList(args: any) {
    const agent = getAgent();
    return agent.getcommitteListProps(args);
  }

  public async getCommitteListAnalytics(args: any) {
    const agent = getAgent();
    return agent.getcommitteListAnalyticsProps(args);
  }

  public async updateMaxInvites(args: any) {
    const agent = getAgent();
    return agent.getUpdateMaxInvites(args);
  }

  public async getSingleCommitte(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getSingleCommitteProps(args);
  }
}
